import '@babel/polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import docReady from './docReady'
import Form from './components/form'
import '../styles/style.sass'

docReady(() => {
  let element = document.getElementById('event-registration')

  if (element) {
    ReactDOM.render(
      <Form
        endpoint={element.dataset.endpoint}
        terminal={element.dataset.terminal}
        loggedin={element.dataset.loggedin}
      />,
      element
    )
  }
})
